import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Logger } from '~/lib/logger';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const logger = new Logger('ErrorBoundary');

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorInfo, setErrorInfo] = useState<Error | null>(null);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      setHasError(true);
      setErrorInfo(event.error);
      logger.error(event.error);
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  const handleReset = () => {
    setHasError(false);
    setErrorInfo(null);
    window.location.reload();
  };

  if (hasError) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography variant="h4" sx={(theme) => ({ color: theme.palette.error.main })}>
          Oops, something went wrong.
        </Typography>
        {errorInfo && (
          <Box mt={2}>
            <Typography variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {errorInfo.message}
            </Typography>
          </Box>
        )}
        <Box mt={4}>
          <Button variant="contained" color="primary" onClick={handleReset}>
            Reload
          </Button>
        </Box>
      </Box>
    );
  }

  return <Box>{children}</Box>;
};
